import {
  WELCOME_EMIRATES_ID_LOGIN_METHOD,
  WELCOME_PATH,
} from '@/modules/welcome/utils/welcomeLoginQuery';

/** Flat public routes (avoid folder trailing-slash static export issues). */
export const BLOOM_UNIVERSAL_HUB_PATH = '/universal';
export const BLOOM_UNIVERSAL_SPACE_PATH = '/universal-space';

/** Marketing shareable: Welcome + login dialog on Emirates ID step. */
export const WELCOME_EMIRATES_ID_LOGIN_PATH = `${WELCOME_PATH}?login=1&method=${WELCOME_EMIRATES_ID_LOGIN_METHOD}`;

/** Hub Properties tile skips space detail and opens guest catalogue. */
export const BLOOM_UNIVERSAL_PROPERTIES_SPACE_KEY = 'properties';
export const BLOOM_UNIVERSAL_PROPERTIES_GUEST_PATH = '/guest';

/**
 * Hub mosaic / space tile target.
 * Properties → guest listing; all other spaces → Universal space detail.
 */
export function resolveBloomUniversalSpaceHref(spaceKey: string): string {
  const key = spaceKey.trim();
  if (key === BLOOM_UNIVERSAL_PROPERTIES_SPACE_KEY) {
    return BLOOM_UNIVERSAL_PROPERTIES_GUEST_PATH;
  }
  return `${BLOOM_UNIVERSAL_SPACE_PATH}?id=${encodeURIComponent(key)}`;
}

/**
 * Welcome web opens the login dialog when `login=1` is present.
 * Ensures hub CTA `/welcome` (and bare `/welcome?...`) opens that dialog.
 */
export function withWelcomeLoginQuery(href: string): string {
  const trimmed = href.trim();
  if (!trimmed.startsWith(WELCOME_PATH)) {
    return trimmed;
  }
  const qIndex = trimmed.indexOf('?');
  const path = qIndex === -1 ? trimmed : trimmed.slice(0, qIndex);
  if (path !== WELCOME_PATH) {
    return trimmed;
  }
  const query = qIndex === -1 ? '' : trimmed.slice(qIndex + 1);
  const params = new URLSearchParams(query);
  if (!params.has('login') && !params.has('openLogin')) {
    params.set('login', '1');
  }
  const nextQuery = params.toString();
  return nextQuery.length > 0 ? `${WELCOME_PATH}?${nextQuery}` : WELCOME_PATH;
}

/** Welcome login dialog opened directly on Emirates ID input (marketing deep link). */
export function withWelcomeEmiratesIdLoginQuery(href: string = WELCOME_PATH): string {
  const withLogin = withWelcomeLoginQuery(href);
  const qIndex = withLogin.indexOf('?');
  const query = qIndex === -1 ? '' : withLogin.slice(qIndex + 1);
  const params = new URLSearchParams(query);
  params.set('method', WELCOME_EMIRATES_ID_LOGIN_METHOD);
  const nextQuery = params.toString();
  return nextQuery.length > 0 ? `${WELCOME_PATH}?${nextQuery}` : WELCOME_PATH;
}
